<template>
  <div class="authoritative-pdf-review2">
    <pdf-view ref="preview" v-bind="$attrs" v-on="$listeners" />
  </div>
</template>

<script>
import PdfView from '../components/pdf_view'

export default {
  name: 'AuthoritativePdfReview',
  inheritAttrs: false,
  components: { PdfView },
  mounted () {
    this.$nextTick(function () {
      if (this.$refs.preview) this.$emit('rendered')
    })
  },
  errorCaptured () {
    this.$emit('render-failed')
    return false
  }
}
</script>

<style scoped>
.authoritative-pdf-review2 {
  min-width: 0;
}
</style>
